export const state = {
  allFlags: []
}

export const getters = {
  allFlags: state => {
    return state.allFlags
  }
}

export const mutations = {
  SET_ALLFLAGS (state, allFlags) {
    state.allFlags = allFlags
  }
}

export const actions = {
  setAllFlags ({ commit }, data) {
    commit('SET_ALLFLAGS', data)
  }
}
